import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "modal-content" }
const _hoisted_3 = { class: "modal-header" }
const _hoisted_4 = { class: "modal-title" }
const _hoisted_5 = { class: "modal-body text-center lead" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { class: "modal-footer justify-content-center" }

import { PropType } from 'vue';
import { useExtendOverlay } from '@overlastic/vue';
import AppPseudo from '../AppPseudo.vue';
import Player from '../../../../shared/app/models/Player.js';
import { Game } from '../../../../shared/game-engine/index.js';


export default /*@__PURE__*/_defineComponent({
  __name: 'GameFinishedOverlay',
  props: {
    game: {
        type: Game,
        required: true,
    },
    players: {
        type: Array as PropType<Player[]>,
        required: true,
    },
},
  setup(__props) {

/* eslint-env browser */
const { visible, resolve } = useExtendOverlay();

const props = __props;

const { players, game } = props;

const winner: null | Player = game.isCanceled()
    ? null
    : players[game.getStrictWinner()]
;


return (_ctx: any,_cache: any) => {
  const _component_i18next = _resolveComponent("i18next")!

  return (_unref(visible))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", {
          class: "modal d-block",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_unref(resolve)()))
        }, [
          _createElementVNode("div", {
            class: "modal-dialog",
            onClick: _cache[2] || (_cache[2] = e => e.stopPropagation())
          }, [
            _createElementVNode("form", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("h5", _hoisted_4, _toDisplayString(_ctx.$t('game_finished_overlay.title')), 1),
                _createElementVNode("button", {
                  type: "button",
                  class: "btn-close",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(resolve)()))
                })
              ]),
              _createElementVNode("div", _hoisted_5, [
                (null !== _unref(winner))
                  ? (_openBlock(), _createElementBlock("p", _hoisted_6, [
                      _createVNode(_component_i18next, {
                        translation: _ctx.$t('player_wins_by.' + (_unref(game).getOutcome() ?? 'default'))
                      }, {
                        player: _withCtx(() => [
                          _createVNode(AppPseudo, {
                            player: _unref(winner),
                            is: "strong",
                            classes: 0 === _unref(game).getStrictWinner() ? 'text-danger' : 'text-primary'
                          }, null, 8, ["player", "classes"])
                        ]),
                        _: 1
                      }, 8, ["translation"])
                    ]))
                  : (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(_ctx.$t('game_has_been_canceled')), 1))
              ]),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-outline-primary",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(resolve)()))
                }, _toDisplayString(_ctx.$t('close')), 1)
              ])
            ])
          ])
        ]),
        _cache[4] || (_cache[4] = _createElementVNode("div", { class: "modal-backdrop show d-fixed" }, null, -1))
      ]))
    : _createCommentVNode("", true)
}
}

})